import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { useAuth, authorizedAxios } from "@moonscape/shared";
import { minutes } from "@/utils";

interface ReferralLink {
  refererUrl: string;
//   totalReferral: number;
//   totalReward: number;
//   unClaimReward: number;
}

interface UseGetReferralProps {
  refetchOnWindowFocus?: boolean;
  staleTime?: number;
}

export const useReferralQueryKey = () => ["GetRefferal"] as const;

export const useGetReferralLink = ({
  refetchOnWindowFocus = true,
  staleTime = 1 * minutes,
}: UseGetReferralProps): {
  isQueryLoading: boolean;
  isIdle: boolean;
  error: unknown;
  data?: ReferralLink;
  refetch: () => void;
} => {
  const { user, getToken } = useAuth();
  const email = user?.email;

  const getRefferalLink = async (): Promise<ReferralLink> => {
    try {
      const token = await getToken();
      const res = await authorizedAxios(token).get(`/referral-codes`);
      return res.data;
    } catch (error) {
      console.error(`[useGetReferral] Failed to fetch referral`, error);
      throw error;
    }
  };

  const {
    isLoading: isQueryLoading,
    isIdle,
    error,
    data,
    refetch,
  }: UseQueryResult<ReferralLink, unknown> = useQuery({
    queryKey: useReferralQueryKey(),
    queryFn: getRefferalLink,
    enabled: !!email,
    refetchOnWindowFocus,
    staleTime,
    keepPreviousData: true,
  });

  return {
    isQueryLoading,
    isIdle,
    error,
    data,
    refetch,
  };
};
